import { useState, useEffect } from "react";

const NuevasFeatures = () => {
  const STORAGE_KEY = "MensajeFeatures";
  const [isVisible, setIsVisible] = useState(() => {
    return localStorage.getItem(STORAGE_KEY) !== "true";
  });

  const handleClose = () => {
    setIsVisible(false);
    localStorage.setItem(STORAGE_KEY, "true");
  };

  useEffect(() => {
    if (localStorage.getItem(STORAGE_KEY) === "true") {
      setIsVisible(false);
    }
  }, []);

  if (!isVisible) return null;

  return (
    <div className="mensaje-panel-features">
      <button onClick={handleClose}>
        X
      </button>
      <img src="/images/bola-de-confeti.svg" alt="Bola" />
      <p>¡Estrenamos nueva interfaz visual! Gracias por elegirnos día a día.</p>
    </div>
  );
};

export default NuevasFeatures;
